// ============================================================================
// Motor de custo do Mercado Livre — portado da referência validada
// (diagnoser-pro/calculadora-meli, vigência da reforma 02/03/2026).
// Tabelas oficiais: frete por reputação × peso tarifado × faixa de preço,
// armazenagem/estoque antigo do Full e comissões (snapshot listing_prices).
//
// Validado contra o caixa real (anúncio MLB4754193130: R$210, Premium, verde,
// Full, 590g, 36×35,6×1,7 → comissão 34,65 · frete 23,65 · custo ML 58,75).
// ============================================================================

export const MLCostTables = {
    // Limite SUPERIOR de cada faixa de peso (kg). idx = primeiro lim onde pesoKg <= lim.
    pesoLims: [0.3, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13, 15, 17, 20, 25, 30, 40, 50, 60, 70, 80, 90, 100, 125, 150, Infinity],
    // Limite SUPERIOR de cada faixa de preço (R$). Colunas:
    // 0:≤18,99 1:19–48,99 2:49–78,99 3:79–99,99 4:100–119,99 5:120–149,99 6:150–199,99 7:≥200
    precoLims: [18.99, 48.99, 78.99, 99.99, 119.99, 149.99, 199.99, Infinity],
    // Frete pago pelo VENDEDOR, desconto por reputação já embutido. 29 faixas × 8 colunas.
    frete: {
        green: [
            [5.65, 6.55, 7.75, 12.35, 14.35, 16.45, 18.45, 20.95], [5.95, 6.65, 7.85, 13.25, 15.45, 17.65, 19.85, 22.55],
            [6.05, 6.75, 7.95, 13.85, 16.15, 18.45, 20.75, 23.65], [6.15, 6.85, 8.05, 14.15, 16.45, 18.85, 21.15, 24.65],
            [6.25, 6.95, 8.15, 14.45, 16.85, 19.25, 21.65, 24.65], [6.35, 7.95, 8.55, 15.75, 18.35, 21.05, 23.65, 26.25],
            [6.45, 8.15, 8.95, 17.05, 19.85, 22.65, 25.55, 28.35], [6.55, 8.35, 9.75, 18.45, 21.55, 24.65, 27.75, 30.75],
            [6.65, 8.55, 9.95, 25.45, 28.55, 32.65, 35.75, 39.75], [6.75, 8.75, 10.15, 27.05, 31.05, 36.05, 40.05, 44.05],
            [6.85, 8.95, 10.35, 28.85, 33.65, 38.45, 43.25, 48.05], [6.95, 9.15, 10.55, 29.65, 34.55, 39.55, 44.45, 49.35],
            [7.05, 9.55, 10.95, 41.25, 48.05, 54.95, 61.75, 68.65], [7.15, 9.95, 11.35, 42.15, 49.25, 56.25, 63.25, 70.25],
            [7.25, 10.15, 11.55, 45.05, 52.45, 59.95, 67.45, 74.95], [7.35, 10.35, 11.75, 48.55, 56.05, 63.55, 70.75, 78.65],
            [7.45, 10.55, 11.95, 54.75, 63.85, 72.95, 82.05, 91.15], [7.65, 10.95, 12.15, 64.05, 75.05, 84.75, 95.35, 105.95],
            [7.75, 11.15, 12.35, 65.95, 75.45, 85.55, 96.25, 106.95], [7.85, 11.35, 12.55, 67.75, 78.95, 88.95, 99.15, 107.05],
            [7.95, 11.55, 12.75, 70.25, 81.05, 92.05, 102.55, 110.75], [8.05, 11.75, 12.95, 74.95, 86.45, 98.15, 109.35, 118.15],
            [8.15, 11.95, 13.15, 80.25, 92.95, 105.05, 117.15, 126.55], [8.25, 12.15, 13.35, 83.95, 97.05, 109.85, 122.45, 132.25],
            [8.35, 12.35, 13.55, 93.25, 107.45, 122.05, 136.05, 146.95], [8.45, 12.55, 13.75, 106.55, 123.95, 139.55, 155.55, 167.95],
            [8.55, 12.75, 13.95, 119.25, 138.05, 156.05, 173.95, 187.95], [8.65, 12.75, 14.15, 126.55, 146.15, 165.65, 184.65, 199.45],
            [8.75, 12.95, 14.35, 166.15, 192.45, 217.55, 242.55, 261.95]
        ],
        yellow: [
            [6.46, 7.49, 8.86, 14.82, 17.22, 19.74, 22.14, 25.14], [6.80, 7.60, 8.97, 15.90, 18.54, 21.18, 23.82, 27.06],
            [6.91, 7.71, 9.09, 16.62, 19.38, 22.14, 24.90, 28.38], [7.03, 7.83, 9.20, 16.98, 19.74, 22.62, 25.38, 29.58],
            [7.14, 7.94, 9.31, 17.34, 20.22, 23.10, 25.98, 29.58], [7.26, 9.09, 9.77, 18.90, 22.02, 25.26, 28.38, 31.50],
            [7.37, 9.31, 10.23, 20.46, 23.82, 27.18, 30.66, 34.02], [7.49, 9.54, 11.14, 22.14, 25.86, 29.58, 33.30, 36.90],
            [7.60, 9.77, 11.37, 30.54, 34.26, 39.18, 42.90, 47.70], [7.71, 10.00, 11.60, 32.46, 37.26, 43.26, 48.06, 52.86],
            [7.83, 10.23, 11.83, 34.62, 40.38, 46.14, 51.90, 57.66], [7.94, 10.46, 12.06, 35.58, 41.46, 47.46, 53.34, 59.22],
            [8.06, 10.91, 12.51, 49.50, 57.66, 65.94, 74.10, 82.38], [8.17, 11.37, 12.97, 50.58, 59.10, 67.50, 75.90, 84.30],
            [8.29, 11.60, 13.20, 54.06, 62.94, 71.94, 80.94, 89.94], [8.40, 11.83, 13.43, 58.26, 67.26, 76.26, 84.90, 94.38],
            [8.51, 12.06, 13.66, 65.70, 76.62, 87.54, 98.46, 109.38], [8.74, 12.51, 13.89, 76.86, 90.06, 101.70, 114.42, 127.14],
            [8.86, 12.74, 14.11, 79.14, 90.54, 102.66, 115.50, 128.34], [8.97, 12.97, 14.34, 81.30, 94.74, 106.74, 118.98, 128.46],
            [9.09, 13.20, 14.57, 84.30, 97.26, 110.46, 123.06, 132.90], [9.20, 13.43, 14.80, 89.94, 103.74, 117.78, 131.22, 141.78],
            [9.31, 13.66, 15.03, 96.30, 111.54, 126.06, 140.58, 151.86], [9.43, 13.89, 15.26, 100.74, 116.46, 131.82, 146.94, 158.70],
            [9.54, 14.11, 15.49, 111.90, 128.94, 146.46, 163.26, 176.34], [9.66, 14.34, 15.71, 127.86, 148.74, 167.46, 186.66, 201.54],
            [9.77, 14.57, 15.94, 143.10, 165.66, 187.26, 208.74, 225.54], [9.89, 14.57, 16.17, 151.86, 175.38, 198.78, 221.58, 239.34],
            [10.00, 14.57, 16.40, 199.38, 230.94, 261.06, 291.06, 314.34]
        ],
        red: [
            [8.07, 9.36, 11.07, 24.70, 28.70, 32.90, 36.90, 41.90], [8.50, 9.50, 11.21, 26.50, 30.90, 35.30, 39.70, 45.10],
            [8.64, 9.64, 11.36, 27.70, 32.30, 36.90, 41.50, 47.30], [8.79, 9.79, 11.50, 28.30, 32.90, 37.70, 42.30, 49.30],
            [8.93, 9.93, 11.64, 28.90, 33.70, 38.50, 43.30, 49.30], [9.07, 11.36, 12.21, 31.50, 36.70, 42.10, 47.30, 52.50],
            [9.21, 11.64, 12.79, 34.10, 39.70, 45.30, 51.10, 56.70], [9.36, 11.93, 13.93, 36.90, 43.10, 49.30, 55.50, 61.50],
            [9.50, 12.21, 14.21, 50.90, 57.10, 65.30, 71.50, 79.50], [9.64, 12.50, 14.50, 54.10, 62.10, 72.10, 80.10, 88.10],
            [9.79, 12.79, 14.79, 57.70, 67.30, 76.90, 86.50, 96.10], [9.93, 13.07, 15.07, 59.30, 69.10, 79.10, 88.90, 98.70],
            [10.07, 13.64, 15.64, 82.50, 96.10, 109.90, 123.50, 137.30], [10.21, 14.21, 16.21, 84.30, 98.50, 112.50, 126.50, 140.50],
            [10.36, 14.50, 16.50, 90.10, 104.90, 119.90, 134.90, 149.90], [10.50, 14.79, 16.79, 97.10, 112.10, 127.10, 141.50, 157.30],
            [10.64, 15.07, 17.07, 109.50, 127.70, 145.90, 164.10, 182.30], [10.93, 15.64, 17.36, 128.10, 150.10, 169.50, 190.70, 211.90],
            [11.07, 15.93, 17.64, 131.90, 150.90, 171.10, 192.50, 213.90], [11.21, 16.21, 17.93, 135.50, 157.90, 177.90, 198.30, 214.10],
            [11.36, 16.50, 18.21, 140.50, 162.10, 184.10, 205.10, 221.50], [11.50, 16.79, 18.50, 149.90, 172.90, 196.30, 218.70, 236.30],
            [11.64, 17.07, 18.79, 160.50, 185.90, 210.10, 234.30, 253.10], [11.79, 17.36, 19.07, 167.90, 194.10, 219.70, 244.90, 264.50],
            [11.93, 17.64, 19.36, 186.50, 214.90, 244.10, 272.10, 293.90], [12.07, 17.93, 19.64, 213.10, 247.90, 279.10, 311.10, 335.90],
            [12.21, 18.21, 19.93, 238.50, 276.10, 312.10, 347.90, 375.90], [12.36, 18.21, 20.21, 253.10, 292.30, 331.30, 369.30, 398.90],
            [12.50, 18.21, 20.50, 332.30, 384.90, 435.10, 485.10, 523.90]
        ]
    },
    armazenagemDia: { pequeno: 0.007, medio: 0.015, grande: 0.050, extragrande: 0.107 },
    estoqueAntigo: {
        pequeno: [0, 1.00, 12.00, 28.00], medio: [0, 2.00, 15.90, 35.00],
        grande: [0, 6.00, 40.00, 92.00], extragrande: [0, 8.00, 52.00, 145.00]
    },
    // Comissões snapshot (price-independent). Bases de Corte = MLB271570.
    // OBS: o gestor optou por Clássico 12% (a API observou 11,5%); manter ambos documentados.
    comissoes: {
        MLB271570: { nome: 'Bases de Corte', classico: 12, premium: 16.5 },
        MLB105458: { nome: 'Colas', classico: 11.5, premium: 16.5 },
        MLB372032: { nome: 'Outros (MLB372032)', classico: 11, premium: 14 },
        MLB270264: { nome: 'Outros (MLB270264)', classico: 11, premium: 14 }
    },
    DIVISOR_VOL: 6000
};

export const MLCostEngine = {
    idxPeso(kg) { return MLCostTables.pesoLims.findIndex(l => kg <= l); },
    idxPreco(preco) { return MLCostTables.precoLims.findIndex(l => preco <= l); },
    pesoVolumetrico(c, l, a) { return (c * l * a) / MLCostTables.DIVISOR_VOL; },

    classificarTamanho(c, l, a, kg) {
        const d = [c, l, a].sort((x, y) => x - y);
        const cabe = (lims) => { const L = [...lims].sort((x, y) => x - y); return d[0] <= L[0] && d[1] <= L[1] && d[2] <= L[2]; };
        if (kg <= 18 && cabe([12, 15, 25])) return 'pequeno';
        if (kg <= 18 && cabe([28, 36, 51])) return 'medio';
        if (kg <= 18 && cabe([60, 60, 70])) return 'grande';
        return 'extragrande';
    },

    // Frete pago pelo vendedor para um dado preço.
    frete(input, repOverride) {
        const rep = repOverride || input.reputacao || 'green';
        const tbl = MLCostTables.frete[rep];
        const ip = this.idxPeso(input.pesoTarifadoKg);
        const preco = input.preco;
        if (input.tipoAnuncio === 'free') return 0;
        if (preco >= 79) return tbl[ip][this.idxPreco(preco)];
        if (preco >= 19) {
            if (input.ofereceGratis) return tbl[ip][3];
            return tbl[ip][this.idxPreco(preco)];
        }
        if (input.ofereceGratis) return Math.min(tbl[ip][0], preco / 2);
        return 0;
    },

    idxTempo(dias) { const m = dias / 30; if (m < 4) return 0; if (m < 6) return 1; if (m < 12) return 2; return 3; },

    // Custos do Full que NÃO dependem do preço (fixos em R$).
    custoFullFixo(input) {
        if (!input.full) return { armazenagem: 0, estoqueAntigo: 0, tamanho: null };
        const tamanho = this.classificarTamanho(input.comp, input.larg, input.alt, input.pesoRealKg);
        const armazenagem = MLCostTables.armazenagemDia[tamanho] * (input.dias || 0);
        const estoqueAntigo = MLCostTables.estoqueAntigo[tamanho][this.idxTempo(input.dias || 0)];
        return { armazenagem, estoqueAntigo, tamanho };
    },

    // Custo total do ML para um preço dado (forward). Espelha a referência.
    calcular(input) {
        const pct = input.tipoAnuncio === 'free' ? 0
            : (input.tipoAnuncio === 'premium' ? input.comissaoPremium : input.comissaoClassico);
        const comissao = input.preco * pct / 100;
        const frete = this.frete(input);
        const { armazenagem, estoqueAntigo, tamanho } = this.custoFullFixo(input);
        const custoLogFull = frete + armazenagem + estoqueAntigo;
        let custoML = comissao + custoLogFull;
        let financeiro = 0;
        const liqAntes = input.preco - custoML;
        if (input.antecPct > 0) financeiro = liqAntes * (input.antecPct / 100) * (8 / 30);
        custoML += financeiro;
        const liquido = input.preco - custoML;
        const imposto = input.preco * (input.impostoPct || 0) / 100;
        const margem = liquido - (input.cmv || 0) - imposto;
        return { pct, comissao, frete, armazenagem, estoqueAntigo, financeiro, tamanho, custoML, liquido, imposto, margem, carga: custoML / input.preco };
    }
};
